<template>
    <section class="wallet-marquee" v-if="getMarque">
        <div class="announcement-sec">
            <div class="announcement-icon">
                <img src="@/assets/images/announcement-icon.webp" alt="announcement-icon"/>
            </div>
            <marquee behavior="scroll" direction="left" scrollamount="6">{{ getMarque }}</marquee>
        </div>
    </section>
</template>
<script>
export default {
     name: 'Marque',
    inject: ['walletConfig'],
    computed :{
        getMarque() {
            return this.walletConfig?.announcement?.value;
        },
    },
}
</script>